import React from 'react'

const CustomHTML = ({ html }) => {
    return <div dangerouslySetInnerHTML={{ __html: html }}></div>
}

export default CustomHTML
